/* unplugin-vue-components disabled */import script from "./International.vue?vue&type=script&lang=ts&setup=true"
export * from "./International.vue?vue&type=script&lang=ts&setup=true"

import "./International.vue?vue&type=style&index=0&id=32142034&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32142034"]])

export default __exports__